import { Injectable } from '@angular/core';
import { defer, Observable } from 'rxjs';
import CustomStore from 'devextreme/data/custom_store';
import { HhsgSharedHttpService } from './http.service';
import { HhsgSharedConfigService } from './config.service';
import { HhsgSharedApplication } from '../models/application.model';
import { HhsgSharedClient } from '../models/client.model';
import { HhsgSharedAspDataStoreService } from './asp-data-store.service';
import { HhsgSharedUserApplicationModel } from '../models/user-application-model.model';
import { HhsgUserGridModel } from '../models/user-grid.model';

@Injectable()
export class HhsgSharedUserAdministratorService {
    private readonly _apiServer: string;
	private readonly _controllerName = 'UserAdministrator';

	constructor(
        private _aspDataStoreService: HhsgSharedAspDataStoreService, 
        private _configService: HhsgSharedConfigService, 
        private _httpService: HhsgSharedHttpService) { 
        this._apiServer = _configService.appSettings.stsServer;
    }

	public async getAllApplications(): Promise<HhsgSharedApplication[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedApplication[]>(this._apiServer, this._controllerName, 'GetAllApplications');
	}

	public async getActiveUserApplications(): Promise<HhsgSharedUserApplicationModel[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedUserApplicationModel[]>(this._apiServer, this._controllerName, 'GetActiveUserApplications');
	}	

	public async getAllClients(): Promise<HhsgSharedClient[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedClient[]>(this._apiServer, this._controllerName, `GetActiveClients`);
	}

    public getUsersForCorporationByClients(applicationAbbreviation: string, filterByCurrentApplication: boolean): Observable<CustomStore> {
		return defer(() => this._aspDataStoreService.createASPDataStore({ 
            loadUrl: `${ this._apiServer }/${ this._controllerName }/GetUsersForCorporationByClients/${applicationAbbreviation}/${filterByCurrentApplication}` 
        }));
	}

	public getAllUsersForCorporationByClients(applicationAbbreviation: string, filterByCurrentApplication: boolean): Observable<HhsgUserGridModel[]> {
	   return this._httpService.doGetRequestObservable<HhsgUserGridModel[]>(this._apiServer, this._controllerName, `GetAllUsersForCorporationByClients/${applicationAbbreviation}/${filterByCurrentApplication}`);
	}
}
